export default __webpack_public_path__ + "static/media/boxLogo.67abb265.svg";